// extracted by mini-css-extract-plugin
export default {"checkboxSVG":"GnY2m UIQVj","checkboxSvg":"GnY2m UIQVj","checkbox-container":"F2Grv","checkboxContainer":"F2Grv"};